import type { Namespace } from "@/i18n/types";
import nsOrgEN from "./en";
import nsOrgJA from "./ja";

export const nsOrg = {
  name: "org",
  locales: {
    ja: nsOrgJA,
    en: nsOrgEN,
  },
} satisfies Namespace<"org", typeof nsOrgJA>;
